import React from "react"
import SEO from "../components/common/SEO"
import ServicePageHero from "../components/services/ServicePageHero.jsx"
const massages = [

  {
    id: 1,
    title: "Massage Relaxant",
    duration: "30 min",
    price: "70 DT",
    description:
      "Complet du corps permettant de redonner souplesse, élasticité musclée libérant les différentes tensions.",
  },

  {
    id: 2,
    title: "Massage Relaxant",
    duration: "40 min",
    price: "100 DT",
    description:
      "Version plus longue du massage relaxant pour une détente musculaire approfondie.",
  },

  {
    id: 3,
    title: "Massage Oriental",
    duration: "50 min",
    price: "130 DT",
    description:
      "Un massage du corps complet à l'huile essentielle de rose, fait de gestes lents mais précis pour obtenir une sensation de relâchement intense.",
  },

  {
    id: 4,
    title: "Massage Californien",
    duration: "40 min",
    price: "100 DT",
    description:
      "Massage complet du corps, ses pétrissages détendent les tensions. Il soulage le mal du dos, élimine les toxines, active la circulation sanguine.",
  },

  {
    id: 5,
    title: "Massage Sportif",
    duration: "40 min",
    price: "120 DT",
    description:
      "Il permet de traiter les points douloureux plus en profondeur, de dénouer les tensions localisées, de favoriser une bonne oxygénation des tissus.",
  },

  {
    id: 6,
    title: "Massage Spécial Dos",
    duration: "25 min",
    price: "70 DT",
    description:
      "Insistant sur la région dorsale, il cible réellement les tensions du dos et les dénoueures en profondeur, pour une décontraction totale.",
  },

  {
    id: 7,
    title: "Massage Aux Pierres Chaudes",
    duration: "50 min",
    price: "160 DT",
    description:
      "Permet d'offrir un contraste thermique sur le corps. La chaleur favorise la détente des muscles et des tensions naturelles du corps et rétablit son flux énergétique.",
  },

  {
    id: 8,
    title: "Massage Aux Pierres Chaudes",
    duration: "30 min",
    price: "80 DT",
    description:
      "Pour le dos. Permet d'offrir un contraste thermique sur le dos, la chaleur favorise la détente des muscles et des tensions naturelles du dos (trappée et région lombaire), rétablit son flux énergétique.",
  },

  {
    id: 9,
    title: "Massage Indien",
    duration: "50 min",
    price: "140 DT",
    description:
      "Massage traditionnel indien favorisant l'équilibre énergétique, la relaxation profonde et le bien-être général.",
  },

  {
    id: 10,
    title: "Massage Ayurvédique",
    duration: "50 min",
    price: "140 DT",
    description:
      "Soin complet du corps inspiré de la médecine ayurvédique pour détendre les muscles et harmoniser l'énergie.",
  },

  {
    id: 11,
    title: "Massage Mille et Une Nuit",
    duration: "50 min",
    price: "160 DT",
    description:
      "Massage oriental réalisé avec des huiles aromatiques pour une expérience sensorielle unique.",
  },

  {
    id: 12,
    title: "Massage Mandara 4 Mains",
    duration: "50 min",
    price: "240 DT",
    description:
      "Massage d'exception effectué simultanément par deux praticiens pour une détente absolue.",
  },

  {
    id: 13,
    title: "Massage Circulatoire",
    duration: "30 min",
    price: "80 DT",
    description:
      "Idéal pour soulager les jambes lourdes et stimuler la circulation sanguine.",
  },

  {
    id: 14,
    title: "Réflexologie Plantaire",
    duration: "25 min",
    price: "80 DT",
    description:
      "Technique de pression sur les zones réflexes des pieds favorisant l'équilibre du corps.",
  },

  {
    id: 15,
    title: "Drainage Lymphatique",
    duration: "30 min",
    price: "80 DT",
    description:
      "Massage doux stimulant le système lymphatique et favorisant l'élimination des toxines.",
  },

  {
    id: 16,
    title: "Massage Anti-Cellulite",
    duration: "30 min",
    price: "100 DT",
    description:
      "Massage ciblé aidant à améliorer l'apparence de la peau et la tonicité des tissus.",
  },

  {
    id: 17,
    title: "Massage Crânien",
    duration: "30 min",
    price: "80 DT",
    description:
      "Massage relaxant du cuir chevelu, de la nuque et des épaules pour diminuer le stress.",
  },
];

export default function MassageServices() {
  return (
    <>
      <SEO
        title="Massages Spa Hammamet | Centre SpaLand Saphir Palace & Spa"
        description="Découvrez nos massages relaxants, ayurvédiques, orientaux et thérapeutiques à Hammamet."
        keywords="massage hammamet, massage ayurvédique, massage oriental, spa hammamet"
        url="https://www.yourdomain.com/services/massages"
      />

      <main>
        {/* Hero
        <section
          style={{
            padding: "120px 20px",
            textAlign: "center",
            background: "#f9f6f1",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              marginBottom: "20px",
            }}
          >
            Nos Massages
          </h1>

          <p
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              color: "#666",
            }}
          >
            Découvrez une sélection de massages conçus
            pour détendre le corps, apaiser l'esprit et
            retrouver une sensation profonde de bien-être.
          </p>
        </section>
 
 <section className="relative h-[500px] overflow-hidden">
  <img
    src="/images/service-massage.jpg"
    alt="Massage Spa Hammamet"
    className="absolute inset-0 h-full w-full object-cover"
  />

  <div className="absolute inset-0 bg-black/50" />

  <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center text-white">
    <h1 className="mb-4 text-5xl font-bold">
      Nos Massages
    </h1>

    <p className="max-w-2xl text-lg leading-relaxed">
      Découvrez une sélection de massages conçus
      pour détendre le corps, apaiser l'esprit et
      retrouver une sensation profonde de bien-être.
    </p>
  </div>
</section>
*/}
<ServicePageHero
  title="Nos Massages"
  description="Découvrez une sélection de massages conçus pour détendre le corps, apaiser l'esprit et retrouver une sensation profonde de bien-être."
  image="/images/service-massage.jpg"
/>
        {/* Massage Cards */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns:
                "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "30px",
            }}
          >
            {massages.map((massage) => (
              <div
                key={massage.id}
                style={{
                  background: "#fff",
                  borderRadius: "20px",
                  padding: "30px",
                  boxShadow:
                    "0 10px 30px rgba(0,0,0,0.08)",
                }}
              >
                <h3
                  style={{
                    marginBottom: "15px",
                  }}
                >
                  {massage.title}
                </h3>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "15px",
                    fontWeight: "600",
                    color: "#b8955d",
                  }}
                >
                  <span>{massage.duration}</span>
                  <span>{massage.price}</span>
                </div>

                <p
                  style={{
                    color: "#666",
                    lineHeight: "1.8",
                    marginBottom: "20px",
                  }}
                >
                  {massage.description}
                </p>

                <a
                  href="https://wa.me/21697902051"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    background: "#b8955d",
                    color: "#fff",
                    padding: "12px 24px",
                    borderRadius: "50px",
                    textDecoration: "none",
                    fontWeight: "600",
                  }}
                >
                  Réserver via WhatsApp
                </a>
              </div>
            ))}
          </div>
        </section>
      </main>
    </>
  )
}